import Modernisierung from '@/js/modernisierung';
import Lasten from '@/js/lasten';
import {kaufpreisaufteilung} from '@/js/validation';

const defaultAllgemeineAngaben = () => {
  let vname = window.sessionStorage.getItem('vname');
  let nname = window.sessionStorage.getItem('nname');
  return {
    auftraggeberName1: vname ? vname : undefined,
    auftraggeberName2: nname ? nname : undefined,
    objektart: 'Bitte wählen',
    baujahr: undefined,
    ermittlungsstichtag: undefined,
    wohnungsnummer: undefined,
    anzahlWohneinheiten: undefined,
    anzahlNutzeinheiten: undefined,
    wohnflaeche: undefined,
    nutzflaeche: undefined,
    valid() {
      return kaufpreisaufteilung.allgemeineAngabenKpa({...this});
    },
  };
};

const allgemeineAngaben = defaultAllgemeineAngaben();

const defaultAuftragsdaten = () => {
  return {
    kaufpreis: undefined,
    grundstuecksflaeche: undefined,
    grunderwerbssteuern: undefined,
    notarkostenKaufvertrag: undefined,
    kostenGrundbucheintragung: undefined,
    bodenrichtwertKaufzeitpunkt: undefined,
    vermietetKaufzeitpunkt: false,
    kaltmieteKaufzeitpunkt: undefined,
    valid() {
      return kaufpreisaufteilung.auftragsdaten({...this});
    },
  };
};

const auftragsdaten = defaultAuftragsdaten();

const defaultLasten = () => {
  return {
    baulasten: Lasten.NEIN.value,
    erlaeuterungBaulasten: undefined,
    altlasten: Lasten.NEIN.value,
    erlaeuterungAltlasten: undefined,
    valid() {
      return kaufpreisaufteilung.lasten({...this});
    },
  };
};

const lasten = defaultLasten();

const defaultModernisierungen = () => {
  return {
    kernsanierung: false,
    jahrDerKernsanierung: undefined,
    bodenbelaege: {
      modernisierung: Modernisierung.KEINE.value,
      jahrDerModernisierung: undefined,
    },
    baeder: {
      modernisierung: Modernisierung.KEINE.value,
      jahrDerModernisierung: undefined,
    },
    heizung: {
      modernisierung: Modernisierung.KEINE.value,
      jahrDerModernisierung: undefined,
    },
    leitungen: {
      modernisierung: Modernisierung.KEINE.value,
      jahrDerModernisierung: undefined,
    },
    fenster: {
      modernisierung: Modernisierung.KEINE.value,
      jahrDerModernisierung: undefined,
    },
    daemmung: {
      modernisierung: Modernisierung.KEINE.value,
      jahrDerModernisierung: undefined,
    },
    dach: {
      modernisierung: Modernisierung.KEINE.value,
      jahrDerModernisierung: undefined,
    },
    raumaufteilung: {
      modernisierung: Modernisierung.KEINE.value,
      jahrDerModernisierung: undefined,
    },

    valid() {
      return kaufpreisaufteilung.modernisierungenKpa({...this}, {...allgemeineAngaben});
    },
  };
};

const modernisierungen = defaultModernisierungen();

const defaultAuftragsunterlagen = () => {
  return {
    grundbuchauszug: undefined,
    kaufvertrag: undefined,
    grundriss: undefined,
    mietvertraege: undefined,
    energieausweis: undefined,
    bauunterlagen: undefined,
    teilungserklaerung: undefined,
    zusatzdokument: [],
    valid() {
      return kaufpreisaufteilung.auftragsunterlagen({...this}, {...auftragsdaten});
    },
  };
};

const auftragsunterlagen = defaultAuftragsunterlagen();

const defaultAnsprechpartner = () => {
  let vname = window.sessionStorage.getItem('vname');
  let nname = window.sessionStorage.getItem('nname');
  return {
    nachname: nname ? nname : undefined,
    vorname: vname ? vname : undefined,
    telefon: undefined,
    erlaeuterung: undefined,
    altName: undefined,
    altFunktion: 'Bitte wählen',
    altTelefon: undefined,
    altEmail: undefined,
    valid() {
      return kaufpreisaufteilung.ansprechpartner({...this});
    },
  };
};

const ansprechpartner = defaultAnsprechpartner();

const defaultRechnungData = () => {
  return {
    name1: undefined,
    name2: undefined,
    plz: undefined,
    ort: undefined,
    str: undefined,
    hnr: undefined,
    valid() {
      return kaufpreisaufteilung.defaultRechnung({ ...this });
    },
  }
}

const defaultRechnung = defaultRechnungData();

const defaultAlternativeRechnung = () => {
  return {
    name1: undefined,
    name2: undefined,
    plz: undefined,
    ort: undefined,
    str: undefined,
    hnr: undefined,
    useDefault: true,
    valid() {
      return kaufpreisaufteilung.alternativeRechnung({ ...this });
    }
  }
}

const alternativeRechnung = defaultAlternativeRechnung();

let ausSpeicherGeladen = false;

export const defaultState = () => {
  Object.assign(allgemeineAngaben, defaultAllgemeineAngaben());
  Object.assign(auftragsdaten, defaultAuftragsdaten());
  Object.assign(lasten, defaultLasten());
  Object.assign(modernisierungen, defaultModernisierungen());
  Object.assign(auftragsunterlagen, defaultAuftragsunterlagen());
  Object.assign(ansprechpartner, defaultAnsprechpartner());
  Object.assign(defaultRechnung, defaultRechnungData());
  Object.assign(alternativeRechnung, defaultAlternativeRechnung());
  ausSpeicherGeladen = false;
  return {
    allgemeineAngaben,
    auftragsdaten,
    lasten,
    modernisierungen,
    auftragsunterlagen,
    ansprechpartner,
    ausSpeicherGeladen,
    defaultRechnung,
    alternativeRechnung
  };
};
const state = defaultState();

export default state;
